import {Typography} from '@mui/material';
import React, {useState, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

export interface CollapsableTextProps {
  text?: string;
  maxLength?: number;
  readMoreKey?: string;
  readLessKey?: string;
  className?: string;
}

export const CollapsableText: React.FC<CollapsableTextProps> = ({
  text,
  maxLength = 100,
  readMoreKey = 'components.collapsableText.readMore',
  readLessKey = 'components.collapsableText.readLess',
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {t} = useTranslation();

  const shouldTruncate = useMemo(
    () => (text?.length ? text.length > maxLength : false),
    [text, maxLength]
  );
  const displayText = useMemo(() => {
    if (!shouldTruncate || isExpanded) return text;
    return `${text?.substring(0, maxLength)}...`;
  }, [text, maxLength, shouldTruncate, isExpanded]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  if (!shouldTruncate) {
    return <span className={className}>{text}</span>;
  }

  return (
    <Typography variant="caption" className={className}>
      {displayText}{' '}
      <button
        onClick={handleToggle}
        className="text-primary hover:text-blue-800 font-medium focus:outline-none"
      >
        {isExpanded ? t(readLessKey) : t(readMoreKey)}
      </button>
    </Typography>
  );
};

export default CollapsableText;
